import { useState, useEffect, useCallback, useRef, useMemo } from 'react';

import { useStore } from '30.quickConnect.Stores';
import { UseDataProps } from '10.quickConnect.app/components/shared/Dialogs/SendingAttachmentsDialog/types';
import { DeclarationSynchronizationStatus } from '90.quickConnect.Models/enums';

const useData = (): UseDataProps => {
  const {
    DeclarationStore: { attachmentsToSend, synchronizationStatus, synchronizationError, setSynchronizationStatus },
  } = useStore();

  const [open, setOpen] = useState<boolean>(synchronizationStatus !== DeclarationSynchronizationStatus.NotStarted);

  const onClose = useCallback(() => {
    if (
      synchronizationStatus !== DeclarationSynchronizationStatus.Failed &&
      synchronizationStatus !== DeclarationSynchronizationStatus.Completed
    )
      return;
    setOpen(false);
    setSynchronizationStatus(DeclarationSynchronizationStatus.NotStarted);
  }, [setSynchronizationStatus, synchronizationStatus]);

  const maxAttachmentsRef = useRef<number>(0);

  const progress = useMemo((): number => {
    const totalAttachmentsToSend = Math.max(maxAttachmentsRef.current, attachmentsToSend);
    return Math.round(((totalAttachmentsToSend - attachmentsToSend) * 100) / totalAttachmentsToSend);
  }, [attachmentsToSend]);

  useEffect(() => {
    if (maxAttachmentsRef.current < attachmentsToSend) maxAttachmentsRef.current = attachmentsToSend;

    setOpen(
      synchronizationStatus !== DeclarationSynchronizationStatus.NotStarted &&
        synchronizationStatus !== DeclarationSynchronizationStatus.Completed,
    );
  }, [attachmentsToSend, synchronizationStatus]);

  return {
    open,
    onClose,
    attachmentsToSend,
    progress,
    synchronizationStatus,
    synchronizationError,
    canClose:
      synchronizationStatus === DeclarationSynchronizationStatus.Failed ||
      synchronizationStatus === DeclarationSynchronizationStatus.Completed,
  };
};

export default useData;
